'use strict';

const notifUtil = require('../utils/notificationUtils');

module.exports = function () {
    window.addEventListener('core:display-toast', (event) => {
        const { message, status, button } = event.detail;
        notifUtil.send(message, status, undefined, button);
    });
};
